import axiosPrivate from "@services/axiosPrivate"
import { FACEBOOK_ADVIDEOS_URL } from "src/constants"

export const uploadFacebookAdVideos = async (adAccountId, videoLink, fileName) => {
  return await axiosPrivate.post(
    `act_${adAccountId}/${FACEBOOK_ADVIDEOS_URL}`,
    {
      file_url: videoLink,
      name: fileName // Add the filename here
    }
  )
}

export const getVideoStatus = async (videoId) => {
  return await axiosPrivate.get(`/${videoId}?fields=status`)
}
